"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectInputForm = void 0;
exports.collectInputSubmissionMessage = collectInputSubmissionMessage;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _badge = require("@design/ui/badge");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _input = require("@design/ui/input");
var _inputGroup = require("@design/ui/input-group");
var _utils = require("@design/lib/utils");
var _checkbox = require("@design/ui/checkbox");
var _field = require("@design/ui/field");
var _item = require("@design/ui/item");
var _questionnaire = require("@design/ui/questionnaire");
var _radioGroup = require("@design/ui/radio-group");
var _select = require("@design/ui/select");
var _spinner = require("@design/ui/spinner");
var _textarea = require("@design/ui/textarea");
var _icertis = require("@common/schemas/icertis");
var _SearchableSelect = require("./SearchableSelect");
var _hoverTooltip = require("./hover-tooltip");
var _lookupOptions = require("./lookup-options");
var _collectInputLinkHref = require("@common/utils/collectInputLinkHref");
var _collectInputDependencies = require("@common/utils/collectInputDependencies");
var _templateSelection = require("@common/utils/templateSelection");
var _copyRichText = require("@common/utils/copyRichText");
var _editorSidesParty = require("@common/utils/editorSidesParty");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SUBMIT_REFUSED_MESSAGE = "Your answers were not sent because the chat is still busy. Change an answer or press Submit to send them.";
var SUBMIT_FAILED_MESSAGE = "Could not submit your answers. Please try again.";
var OTHER_LABEL = "Other…";
var COPY_FEEDBACK_MS = 1500;
var COPY_OUTCOME_LABELS = {
  copied: "Copied",
  failed: "Copy failed"
};
var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var INVALID_EMAIL_TITLE = "Not a valid email address";
var EYEBROW_CLASS = "text-label-sm tracking-wide text-foreground-muted uppercase";
var FORM_TOOLTIP_DELAY_MS = 400;
var OTHER_CHOICE_LABEL = "other";
function choicesIncludeTheirOwnOther(options) {
  return options.some(function (option) {
    return option.label.trim().replace(/[\.:\u2026]+$/, "").toLowerCase() === OTHER_CHOICE_LABEL;
  });
}
function offersTypedOtherAnswer(field, options) {
  return !!field.allow_other && !choicesIncludeTheirOwnOther(options);
}
var CITATION_HREF_PREFIX = "cite:";
var SOURCE_NOTE_ELEMENTS = ["p", "a", "strong", "em", "code"];
var PLACED_EDITOR_SIDES = ["our_side", "counterparty"];
var OTHER_EDITOR_SIDE = {
  our_side: "counterparty",
  counterparty: "our_side"
};
var EDITOR_SIDE_NAME = {
  our_side: "our side",
  counterparty: "the counterparty"
};
var EDITOR_COLUMN_HEAD = {
  our_side: "Our side",
  counterparty: "Counterparty"
};
var EDITOR_PLACE_BUTTON_TEXT = {
  our_side: "Ours",
  counterparty: "Theirs"
};
var EDITOR_COLUMN_ROLE_WHEN_ACTING_FOR_THE_COUNTERPARTY = OTHER_EDITOR_SIDE;
var EDITOR_COLUMN_ROLE_WHEN_ACTING_FOR_THE_OFFERED_PARTY = {
  our_side: "our_side",
  counterparty: "counterparty"
};
var LIST_SEPARATORS = {
  email: /[,;\s]+/,
  text: /,/
};
function isValidListItem(itemType, item) {
  return itemType === "email" ? EMAIL_PATTERN.test(item) : item.trim().length > 0;
}
function isSelectField(field) {
  return field.type === "single_select" || field.type === "multi_select";
}
function isTemplatePickField(field) {
  return field.type === "single_select" && field.narrowed_by_template_selection === true;
}
function isAnsweredInOneEntry(field) {
  return field.type !== "multi_select" && field.type !== "list" && field.type !== "editor_sides";
}
var CLICK_ONLY_INPUT_TYPES = new Set(["checkbox", "radio", "button", "submit"]);
var OPTION_SEARCH_INPUT_ROLE = "combobox";
function isTypedInto(target) {
  if (target instanceof HTMLTextAreaElement) return true;
  return target instanceof HTMLInputElement && !CLICK_ONLY_INPUT_TYPES.has(target.type) && target.getAttribute("role") !== OPTION_SEARCH_INPUT_ROLE;
}
function choiceTypeFor(field) {
  return field.type === "multi_select" ? "checkbox" : "radio";
}
function splitCurrencyValue(value, currencies) {
  var trimmed = value.trim();
  var code = trimmed.slice(-3).toUpperCase();
  return currencies.includes(code) ? {
    amount: trimmed.slice(0, -3).trim(),
    currency: code
  } : {
    amount: trimmed,
    currency: currencies[0]
  };
}
function preselectedIndexes(field) {
  var _field$options$findIn, _field$options;
  if (field.type !== "single_select" || !field.value) return [];
  var index = (_field$options$findIn = (_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.findIndex(function (option) {
    return option.label === field.value;
  })) !== null && _field$options$findIn !== void 0 ? _field$options$findIn : -1;
  return index >= 0 ? [index] : [];
}
function initialValue(field) {
  var _field$value, _field$value2;
  if (isSelectField(field)) return {
    type: "select",
    selected: preselectedIndexes(field),
    otherText: ""
  };
  if (field.type === "list") return {
    type: "list",
    items: (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : []
  };
  if (field.type === "editor_sides") return {
    type: "editor_sides",
    editors: field.editors
  };
  var prefill = (_field$value2 = field.value) !== null && _field$value2 !== void 0 ? _field$value2 : "";
  if (field.type === "currency") return _objectSpread({
    type: "currency"
  }, splitCurrencyValue(prefill, field.currencies));
  return {
    type: "text",
    value: prefill
  };
}
function initialValues(fields, seed) {
  var values = {};
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _seed$field$id;
      var field = _step.value;
      values[field.id] = (_seed$field$id = seed === null || seed === void 0 ? void 0 : seed[field.id]) !== null && _seed$field$id !== void 0 ? _seed$field$id : initialValue(field);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return values;
}
function fieldOptions(field, resolvedOptions) {
  var _field$options2, _resolvedOptions$fiel;
  if (!isSelectField(field)) return [];
  return (_field$options2 = field.options) !== null && _field$options2 !== void 0 && _field$options2.length ? field.options : (_resolvedOptions$fiel = resolvedOptions === null || resolvedOptions === void 0 ? void 0 : resolvedOptions[field.id]) !== null && _resolvedOptions$fiel !== void 0 ? _resolvedOptions$fiel : [];
}
function selectedOptionAnswer(options, index) {
  var option = options[index];
  if (!option) return null;
  var isAmbiguous = options.filter(function (candidate) {
    return candidate.label === option.label;
  }).length > 1;
  return isAmbiguous ? "".concat(option.label, " (option ").concat(index + 1, ")") : option.label;
}
function editorSideGroupName(field, side) {
  if (side === "unplaced") return "neither party";
  var label = side === "our_side" ? field.our_side_label : field.counterparty_label;
  var group = side === "our_side" ? "our side" : "counterparty";
  return label ? "".concat(group, " (").concat(label, ")") : group;
}
function editorSidesAnswer(field, editors) {
  var sides = ["our_side", "counterparty", "unplaced"];
  return sides.map(function (side) {
    return {
      side: side,
      names: editors.filter(function (editor) {
        return editor.side === side;
      }).map(function (editor) {
        return editor.name;
      })
    };
  }).filter(function (_ref) {
    var names = _ref.names;
    return names.length > 0;
  }).map(function (_ref2) {
    var side = _ref2.side,
      names = _ref2.names;
    return "".concat(editorSideGroupName(field, side), ": ").concat(names.join(", "));
  }).join("; ");
}
function fieldAnswerStrings(field, value, resolvedOptions) {
  if (field.type === "editor_sides" && (value === null || value === void 0 ? void 0 : value.type) === "editor_sides") {
    return [editorSidesAnswer(field, value.editors)];
  }
  if (isSelectField(field) && (value === null || value === void 0 ? void 0 : value.type) === "select") {
    var _value$otherText;
    var options = fieldOptions(field, resolvedOptions);
    var chosen = value.selected.map(function (index) {
      return selectedOptionAnswer(options, index);
    }).filter(function (label) {
      return label !== null;
    });
    var otherText = (_value$otherText = value.otherText) === null || _value$otherText === void 0 ? void 0 : _value$otherText.trim();
    var other = value.selected.includes(_icertis.OTHER_INDEX) && otherText ? [field.strict ? "".concat(otherText, " (custom value \u2014 outside the closed option list; may not be accepted on save)") : otherText] : [];
    return [].concat(_toConsumableArray(chosen), other);
  }
  if (field.type === "list" && (value === null || value === void 0 ? void 0 : value.type) === "list") {
    return value.items.map(function (item) {
      return item.trim();
    }).filter(Boolean);
  }
  if (field.type === "currency" && (value === null || value === void 0 ? void 0 : value.type) === "currency") {
    return value.amount.trim() ? ["".concat(value.amount.trim(), " ").concat(value.currency)] : [];
  }
  if ((value === null || value === void 0 ? void 0 : value.type) === "text") {
    return value.value.trim() ? [value.value.trim()] : [];
  }
  return [];
}
function answerLabels(field, value, resolvedOptions) {
  var _value$otherText2;
  if (!isSelectField(field) || (value === null || value === void 0 ? void 0 : value.type) !== "select") return fieldAnswerStrings(field, value, resolvedOptions);
  var options = fieldOptions(field, resolvedOptions);
  var chosen = value.selected.flatMap(function (index) {
    return options[index] ? [options[index].label] : [];
  });
  var otherText = (_value$otherText2 = value.otherText) === null || _value$otherText2 === void 0 ? void 0 : _value$otherText2.trim();
  return value.selected.includes(_icertis.OTHER_INDEX) && otherText ? [].concat(_toConsumableArray(chosen), [otherText]) : chosen;
}
function listItemsValid(field, value) {
  if (field.type !== "list" || (value === null || value === void 0 ? void 0 : value.type) !== "list") return true;
  return value.items.every(function (item) {
    return isValidListItem(field.item_type, item);
  });
}
function isFieldAnswered(field, value, resolvedOptions) {
  return fieldAnswerStrings(field, value, resolvedOptions).length > 0 && listItemsValid(field, value);
}
var REQUIRED_MESSAGE = "Required";
var EMPTY_ITEM_MESSAGE = "Empty item";
function fieldCanBlockSubmit(field) {
  return field.type === "list" || !!field.required;
}
function submitBlockerFor(field, value, resolvedOptions) {
  if (field.type === "list" && (value === null || value === void 0 ? void 0 : value.type) === "list") {
    var invalidItems = value.items.filter(function (item) {
      return !isValidListItem(field.item_type, item);
    });
    if (invalidItems.length) {
      var message = field.item_type === "email" ? "".concat(INVALID_EMAIL_TITLE, ": ").concat(invalidItems.join(", ")) : EMPTY_ITEM_MESSAGE;
      return {
        fieldId: field.id,
        fieldLabel: field.label,
        kind: "invalid_item",
        message: message
      };
    }
  }
  if (field.required && !isFieldAnswered(field, value, resolvedOptions)) {
    return {
      fieldId: field.id,
      fieldLabel: field.label,
      kind: "required",
      message: REQUIRED_MESSAGE
    };
  }
  return null;
}
function submitBlockers(fields, values, resolvedOptions) {
  return fields.flatMap(function (field) {
    var blocker = submitBlockerFor(field, values[field.id], resolvedOptions);
    return blocker ? [blocker] : [];
  });
}
function collectInputSubmissionMessage(title, fields, values, resolvedOptions, formId) {
  var picked = (0, _editorSidesParty.fieldsAndValuesForThePickedParty)(fields, values, resolvedOptions);
  var lines = picked.fields.map(function (field) {
    var parts = fieldAnswerStrings(field, picked.values[field.id], resolvedOptions);
    return parts.length ? "- ".concat(field.label, ": ").concat(parts.join(", ")) : null;
  }).filter(function (line) {
    return line !== null;
  });
  var summary = title ? "".concat(title, ":\n").concat(lines.join("\n")) : lines.join("\n");
  return formId ? "".concat(summary, "\n\n<scroll-to-form id=\"").concat(formId, "\"></scroll-to-form>") : summary;
}
function citationNamedByHref(href, citations) {
  if (!(href !== null && href !== void 0 && href.startsWith(CITATION_HREF_PREFIX))) return undefined;
  var paragraphId = href.slice(CITATION_HREF_PREFIX.length);
  return citations === null || citations === void 0 ? void 0 : citations.find(function (citation) {
    return citation.paragraph_id === paragraphId;
  });
}
var SourceNote = function SourceNote(_ref3) {
  var text = _ref3.text,
    citations = _ref3.citations,
    onOpenCitation = _ref3.onOpenCitation;
  var components = {
    p: function p(_ref4) {
      var children = _ref4.children;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: children
      });
    },
    a: function a(_ref5) {
      var href = _ref5.href,
        children = _ref5.children;
      var citation = citationNamedByHref(href, citations);
      if (!citation || !onOpenCitation) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: children
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: "#",
        className: "text-foreground-link underline underline-offset-4",
        title: "Show the cited paragraph",
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onOpenCitation(citation);
        },
        children: children
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
    allowedElements: SOURCE_NOTE_ELEMENTS,
    unwrapDisallowed: true,
    urlTransform: function urlTransform(url) {
      return url;
    },
    components: components,
    "data-sentry-element": "Markdown",
    "data-sentry-component": "SourceNote",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: text
  });
};
var FieldNote = function FieldNote(_ref6) {
  var field = _ref6.field,
    onOpenCitation = _ref6.onOpenCitation;
  if (!field.description) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "text-caption text-foreground-muted",
    "data-sentry-component": "FieldNote",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SourceNote, {
      text: field.description,
      citations: field.citations,
      onOpenCitation: onOpenCitation,
      "data-sentry-element": "SourceNote",
      "data-sentry-source-file": "CollectInputForm.tsx"
    })
  });
};
var ROW_CHOICE_CLASS = {
  radio: "w-auto grow",
  checkbox: "w-auto"
};
var ROW_CHOICE_GROUP_CLASS = {
  radio: "flex flex-wrap",
  checkbox: "flex-row flex-wrap"
};
var Choice = function Choice(_ref7) {
  var controlId = _ref7.controlId,
    index = _ref7.index,
    label = _ref7.label,
    description = _ref7.description,
    citations = _ref7.citations,
    type = _ref7.type,
    selected = _ref7.selected,
    disabled = _ref7.disabled,
    row = _ref7.row,
    onToggle = _ref7.onToggle,
    onOpenCitation = _ref7.onOpenCitation;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
    orientation: "horizontal",
    className: (0, _utils.cn)(row && ROW_CHOICE_CLASS[type], disabled && !selected && "opacity-50"),
    "data-sentry-element": "Field",
    "data-sentry-component": "Choice",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: [type === "radio" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_radioGroup.RadioGroupItem, {
      id: controlId,
      value: String(index),
      disabled: disabled,
      className: "disabled:opacity-100"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
      id: controlId,
      checked: selected,
      disabled: disabled,
      onCheckedChange: function onCheckedChange() {
        return onToggle === null || onToggle === void 0 ? void 0 : onToggle(index);
      },
      className: "disabled:opacity-100"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.FieldContent, {
      "data-sentry-element": "FieldContent",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
        htmlFor: controlId,
        "data-sentry-element": "FieldLabel",
        "data-sentry-source-file": "CollectInputForm.tsx",
        children: label
      }), description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldDescription, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SourceNote, {
          text: description,
          citations: citations,
          onOpenCitation: onOpenCitation
        })
      }) : null]
    })]
  });
};
var ChoiceRow = function ChoiceRow(_ref8) {
  var options = _ref8.options,
    selected = _ref8.selected,
    type = _ref8.type,
    disabled = _ref8.disabled,
    onToggle = _ref8.onToggle,
    row = _ref8.row,
    _ref8$showDescription = _ref8.showDescriptions,
    showDescriptions = _ref8$showDescription === void 0 ? true : _ref8$showDescription,
    allowOther = _ref8.allowOther,
    onOpenCitation = _ref8.onOpenCitation;
  var groupId = (0, _react.useId)();
  var choices = options.map(function (option, index) {
    return {
      option: option,
      index: index
    };
  });
  if (allowOther) choices.push({
    option: {
      label: OTHER_LABEL
    },
    index: _icertis.OTHER_INDEX
  });
  var className = row ? ROW_CHOICE_GROUP_CLASS[type] : undefined;
  var items = choices.map(function (_ref9) {
    var option = _ref9.option,
      index = _ref9.index;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Choice, {
      controlId: "".concat(groupId, "-").concat(index),
      index: index,
      label: option.label,
      description: showDescriptions ? option.description : null,
      citations: option.citations,
      type: type,
      selected: selected.includes(index),
      disabled: disabled,
      row: row,
      onToggle: onToggle,
      onOpenCitation: onOpenCitation
    }, index);
  });
  return type === "radio" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_radioGroup.RadioGroup, {
    value: selected.length ? String(selected[0]) : null,
    onValueChange: function onValueChange(value) {
      return onToggle === null || onToggle === void 0 ? void 0 : onToggle(Number(value));
    },
    disabled: disabled,
    className: className,
    "data-sentry-element": "RadioGroup",
    "data-sentry-component": "ChoiceRow",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: items
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldGroup, {
    "data-slot": "checkbox-group",
    className: className,
    "data-sentry-element": "FieldGroup",
    "data-sentry-component": "ChoiceRow",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: items
  });
};
function alphabeticalEditors(editors) {
  return _toConsumableArray(editors).sort(function (left, right) {
    return left.name.localeCompare(right.name);
  });
}
var EDITOR_COLUMNS_CLASS = "grid grid-cols-2 items-start gap-2";
var EDITOR_COLUMN_CLASS = "flex min-w-0 flex-col gap-2";
var EditorSidesBoard = function EditorSidesBoard(_ref0) {
  var field = _ref0.field,
    editors = _ref0.editors,
    confirmed = _ref0.confirmed,
    actingForTheCounterparty = _ref0.actingForTheCounterparty,
    onMove = _ref0.onMove;
  var roleOfColumn = actingForTheCounterparty ? EDITOR_COLUMN_ROLE_WHEN_ACTING_FOR_THE_COUNTERPARTY : EDITOR_COLUMN_ROLE_WHEN_ACTING_FOR_THE_OFFERED_PARTY;
  var partyOfColumn = {
    our_side: field.our_side_label,
    counterparty: field.counterparty_label
  };
  var sideLabel = {
    our_side: partyOfColumn.our_side ? "".concat(EDITOR_COLUMN_HEAD[roleOfColumn.our_side], " \xB7 ").concat(partyOfColumn.our_side) : EDITOR_COLUMN_HEAD[roleOfColumn.our_side],
    counterparty: partyOfColumn.counterparty ? "".concat(EDITOR_COLUMN_HEAD[roleOfColumn.counterparty], " \xB7 ").concat(partyOfColumn.counterparty) : EDITOR_COLUMN_HEAD[roleOfColumn.counterparty]
  };
  var unplacedEditors = alphabeticalEditors(editors.filter(function (editor) {
    return editor.side === "unplaced";
  }));
  var isUnsure = function isUnsure(editor) {
    return editor.unsure && !confirmed;
  };
  function editorsOn(side, unsure) {
    return alphabeticalEditors(editors.filter(function (editor) {
      return editor.side === side && isUnsure(editor) === unsure;
    }));
  }
  function renderSwapButton(editor, side) {
    if (!onMove) return null;
    var destination = OTHER_EDITOR_SIDE[side];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "aria-label": "Move ".concat(editor.name, " to ").concat(EDITOR_SIDE_NAME[roleOfColumn[destination]]),
      title: "Move to ".concat(EDITOR_SIDE_NAME[roleOfColumn[destination]]),
      onClick: function onClick() {
        return onMove(editor.name, destination);
      },
      "data-sentry-element": "Button",
      "data-sentry-component": "renderSwapButton",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: side === "our_side" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowForwardIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {})
    });
  }
  function renderTile(editor, side) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
      variant: "outline",
      size: "xs",
      className: (0, _utils.cn)("flex-nowrap", side === "counterparty" && "flex-row-reverse", isUnsure(editor) && "card-selected"),
      "data-editor-tile": editor.name,
      "data-side": side,
      "data-unsure": isUnsure(editor),
      "data-sentry-element": "Item",
      "data-sentry-component": "renderTile",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "min-w-0 flex-1 font-medium wrap-anywhere",
        children: editor.name
      }), renderSwapButton(editor, side)]
    }, editor.name);
  }
  function renderColumns(unsure) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: EDITOR_COLUMNS_CLASS,
      "data-sentry-component": "renderColumns",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: PLACED_EDITOR_SIDES.map(function (side) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: EDITOR_COLUMN_CLASS,
          children: editorsOn(side, unsure).map(function (editor) {
            return renderTile(editor, side);
          })
        }, side);
      })
    });
  }
  function renderPlaceButton(editor, side) {
    if (!onMove) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {});
    var buttonText = EDITOR_PLACE_BUTTON_TEXT[roleOfColumn[side]];
    var label = side === "our_side" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {}), buttonText]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [buttonText, /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowForwardIcon, {})]
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "outline",
      size: "xs",
      "aria-label": "Put ".concat(editor.name, " on ").concat(EDITOR_SIDE_NAME[roleOfColumn[side]]),
      onClick: function onClick() {
        return onMove(editor.name, side);
      },
      "data-sentry-element": "Button",
      "data-sentry-component": "renderPlaceButton",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: label
    });
  }
  function renderUnplacedRow(editor) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
      variant: "outline",
      size: "xs",
      className: "card-selected grid grid-cols-[auto_minmax(0,1fr)_auto]",
      "data-editor-tile": editor.name,
      "data-side": "unplaced",
      "data-sentry-element": "Item",
      "data-sentry-component": "renderUnplacedRow",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [renderPlaceButton(editor, "our_side"), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "min-w-0 text-center font-medium wrap-anywhere",
        children: editor.name
      }), renderPlaceButton(editor, "counterparty")]
    }, editor.name);
  }
  var columnHeads = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: EDITOR_COLUMNS_CLASS,
    children: PLACED_EDITOR_SIDES.map(function (side) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: (0, _utils.cn)(EYEBROW_CLASS, "flex min-w-0 items-baseline gap-1.5"),
        children: [sideLabel[side], /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "font-medium",
          children: editors.filter(function (editor) {
            return editor.side === side;
          }).length
        })]
      }, side);
    })
  });
  var hasUnsurePlacements = editors.some(function (editor) {
    return editor.side !== "unplaced" && isUnsure(editor);
  });
  var hardCases = unplacedEditors.length > 0 || hasUnsurePlacements ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: EDITOR_COLUMN_CLASS,
    "data-hard-cases": true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: EYEBROW_CLASS,
      children: confirmed ? "Neither party" : "Check these"
    }), unplacedEditors.map(function (editor) {
      return renderUnplacedRow(editor);
    }), hasUnsurePlacements ? renderColumns(true) : null]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-3",
    "data-sentry-component": "EditorSidesBoard",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: [columnHeads, hardCases, renderColumns(false)]
  });
};
var ChipListInput = function ChipListInput(_ref1) {
  var controlId = _ref1.controlId,
    itemType = _ref1.itemType,
    items = _ref1.items,
    disabled = _ref1.disabled,
    onChange = _ref1.onChange;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    draft = _useState2[0],
    setDraft = _useState2[1];
  var inputRef = (0, _react.useRef)(null);
  var separators = LIST_SEPARATORS[itemType];
  function commit(tokens) {
    var added = Array.from(new Set(tokens.map(function (token) {
      return token.trim();
    }))).filter(Boolean).filter(function (token) {
      return !items.includes(token);
    });
    if (added.length) onChange === null || onChange === void 0 || onChange([].concat(_toConsumableArray(items), _toConsumableArray(added)));
  }
  function handleDraftChange(text) {
    var _tokens$pop;
    if (!separators.test(text)) {
      setDraft(text);
      return;
    }
    var tokens = text.split(separators);
    var trailing = separators.test(text.slice(-1)) ? "" : (_tokens$pop = tokens.pop()) !== null && _tokens$pop !== void 0 ? _tokens$pop : "";
    commit(tokens);
    setDraft(trailing);
  }
  function handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      commit([draft]);
      setDraft("");
      return;
    }
    if (event.key === "Backspace" && !draft && items.length) onChange === null || onChange === void 0 || onChange(items.slice(0, -1));
  }
  function handleBlur() {
    commit([draft]);
    setDraft("");
  }
  function renderChip(item, index) {
    var valid = isValidListItem(itemType, item);
    var remove = disabled ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "data-icon": "inline-end",
      "aria-label": "Remove ".concat(item),
      onClick: function onClick() {
        return onChange === null || onChange === void 0 ? void 0 : onChange(items.filter(function (_, position) {
          return position !== index;
        }));
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {})
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_badge.Badge, {
      "aria-invalid": valid ? undefined : true,
      title: valid ? undefined : INVALID_EMAIL_TITLE,
      "data-sentry-element": "Badge",
      "data-sentry-component": "renderChip",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [item, remove]
    }, "".concat(index, ":").concat(item));
  }
  var input = disabled ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupInput, {
    ref: inputRef,
    id: controlId,
    type: "text",
    inputMode: itemType === "email" ? "email" : "text",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: false,
    className: "min-w-32",
    value: draft,
    placeholder: items.length ? "Add another" : undefined,
    onChange: function onChange(event) {
      return handleDraftChange(event.target.value);
    },
    onKeyDown: handleKeyDown,
    onBlur: handleBlur
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroup, {
    className: "h-auto min-h-9 flex-wrap gap-1 ps-1.5",
    onClick: disabled ? undefined : function () {
      var _inputRef$current;
      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    },
    "data-sentry-element": "InputGroup",
    "data-sentry-component": "ChipListInput",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: [items.map(renderChip), input]
  });
};
var SelectFieldOptions = function SelectFieldOptions(_ref10) {
  var _field$options3;
  var field = _ref10.field,
    optionsUrl = _ref10.optionsUrl,
    fetchLookupOptions = _ref10.fetchLookupOptions,
    onResolved = _ref10.onResolved,
    children = _ref10.children;
  var hasInlineOptions = !!((_field$options3 = field.options) !== null && _field$options3 !== void 0 && _field$options3.length);
  var _useLookupOptions = (0, _lookupOptions.useLookupOptions)(hasInlineOptions ? null : optionsUrl, fetchLookupOptions),
    fetchedLabels = _useLookupOptions.options,
    isLoading = _useLookupOptions.isLoading,
    loadError = _useLookupOptions.loadError;
  var resolved = (0, _react.useMemo)(function () {
    return hasInlineOptions ? field.options : fetchedLabels.map(function (label) {
      return {
        label: label
      };
    });
  }, [hasInlineOptions, field.options, fetchedLabels]);
  (0, _react.useEffect)(function () {
    if (resolved.length) onResolved === null || onResolved === void 0 || onResolved(field.id, resolved);
  }, [field.id, resolved, onResolved]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children(resolved, isLoading, loadError)
  });
};
var FieldFrame = function FieldFrame(_ref11) {
  var field = _ref11.field,
    controlId = _ref11.controlId,
    trailing = _ref11.trailing,
    error = _ref11.error,
    requiredAnswerMissing = _ref11.requiredAnswerMissing,
    children = _ref11.children;
  var labelId = "".concat(field.id, "-label");
  var strict = isSelectField(field) && field.strict;
  var header = field.header ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: EYEBROW_CLASS,
    children: field.header
  }) : null;
  var errorSlot = error === undefined ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireError, {
    role: undefined,
    "aria-live": "polite",
    "data-field-error": field.id,
    className: "min-h-5",
    children: error
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    "data-sentry-component": "FieldFrame",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: [header, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_questionnaire.QuestionnaireItem, {
      "aria-labelledby": controlId ? undefined : labelId,
      "data-sentry-element": "QuestionnaireItem",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_questionnaire.QuestionnaireTitle, {
        className: "flex w-full items-center gap-1",
        "data-sentry-element": "QuestionnaireTitle",
        "data-sentry-source-file": "CollectInputForm.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          htmlFor: controlId,
          id: labelId,
          children: [field.label, field.required ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: (0, _utils.cn)(requiredAnswerMissing && "text-destructive"),
            title: REQUIRED_MESSAGE,
            children: " *"
          }) : null]
        }), strict ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_lookupOptions.StrictFieldInfoTooltip, {
          text: _lookupOptions.STRICT_TOOLTIP_TEXT,
          delayDuration: FORM_TOOLTIP_DELAY_MS
        }) : null, trailing]
      }), children, errorSlot]
    })]
  });
};
var SubmitBlockedTooltip = function SubmitBlockedTooltip(_ref12) {
  var blockers = _ref12.blockers,
    children = _ref12.children;
  var blockerList = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "flex flex-col gap-0.5",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "font-semibold",
      children: "Before you can submit"
    }), blockers.map(function (blocker) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [blocker.fieldLabel, ": ", blocker.message]
      }, blocker.fieldId);
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
    content: blockerList,
    side: "top",
    align: "end",
    active: blockers.length > 0,
    delayDuration: FORM_TOOLTIP_DELAY_MS,
    className: "col-start-3 row-start-1 inline-flex justify-self-end",
    "data-sentry-element": "HoverTooltip",
    "data-sentry-component": "SubmitBlockedTooltip",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: children
  });
};
var TEMPLATE_GROUP_HEADINGS = {
  allowed: "Allowed by your answers",
  always: "Always available (no answer here decides it)"
};
var TEMPLATE_GROUP_ORDER = ["allowed", "always"];
var TemplatePickChoices = function TemplatePickChoices(_ref13) {
  var options = _ref13.options,
    templates = _ref13.templates,
    selected = _ref13.selected,
    disabled = _ref13.disabled,
    onPick = _ref13.onPick;
  var groupId = (0, _react.useId)();
  var optionIndexOf = function optionIndexOf(name) {
    return options.findIndex(function (option) {
      return option.label === name;
    });
  };
  var groups = TEMPLATE_GROUP_ORDER.map(function (availability) {
    return {
      availability: availability,
      templates: templates.filter(function (template) {
        return template.availability === availability && optionIndexOf(template.name) >= 0;
      })
    };
  }).filter(function (group) {
    return group.templates.length > 0;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radioGroup.RadioGroup, {
    value: selected.length ? String(selected[0]) : null,
    onValueChange: function onValueChange(value) {
      return onPick(Number(value));
    },
    disabled: disabled,
    "data-sentry-element": "RadioGroup",
    "data-sentry-component": "TemplatePickChoices",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: groups.map(function (group) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-3",
        "data-testid": "template-group-".concat(group.availability),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "text-caption text-foreground-muted",
          children: TEMPLATE_GROUP_HEADINGS[group.availability]
        }), group.templates.map(function (template) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(Choice, {
            controlId: "".concat(groupId, "-").concat(optionIndexOf(template.name)),
            index: optionIndexOf(template.name),
            label: template.name,
            type: "radio",
            selected: selected.includes(optionIndexOf(template.name)),
            disabled: disabled
          }, template.name);
        })]
      }, group.availability);
    })
  });
};
var CollapsedFields = function CollapsedFields(_ref14) {
  var _fields$0$header;
  var fields = _ref14.fields,
    renderField = _ref14.renderField;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", {
    className: "border-t border-border-subtle pt-3",
    "data-sentry-component": "CollapsedFields",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("summary", {
      className: (0, _utils.cn)(EYEBROW_CLASS, "cursor-pointer"),
      children: [(_fields$0$header = fields[0].header) !== null && _fields$0$header !== void 0 ? _fields$0$header : "More", " (", fields.length, ")"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "mt-3 flex flex-col gap-6",
      children: fields.map(function (field) {
        return renderField(_objectSpread(_objectSpread({}, field), {}, {
          header: null
        }));
      })
    })]
  });
};
var FieldList = function FieldList(_ref15) {
  var fields = _ref15.fields,
    renderField = _ref15.renderField;
  var collapsedFields = fields.filter(function (field) {
    return field.collapsed;
  });
  var openFields = fields.filter(function (field) {
    return !field.collapsed;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [openFields.map(function (field, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [(0, _collectInputDependencies.startsRevealedSection)(openFields, index) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          role: "separator",
          className: "border-t border-border-subtle"
        }) : null, renderField(field)]
      }, field.id);
    }), collapsedFields.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(CollapsedFields, {
      fields: collapsedFields,
      renderField: renderField
    })]
  });
};
var FormCard = function FormCard(_ref16) {
  var title = _ref16.title,
    reason = _ref16.reason,
    formId = _ref16.formId,
    questionnaireProps = _ref16.questionnaireProps,
    children = _ref16.children;
  var header = title || reason ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardHeader, {
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardTitle, {
      children: title
    }) : null, reason ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardDescription, {
      children: reason
    }) : null]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    id: formId,
    size: "sm",
    className: "my-2",
    "data-sentry-element": "Card",
    "data-sentry-component": "FormCard",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: [header, /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.Questionnaire, _objectSpread(_objectSpread({}, questionnaireProps), {}, {
        "data-sentry-element": "Questionnaire",
        "data-sentry-source-file": "CollectInputForm.tsx",
        children: children
      }))
    })]
  });
};
var LockedInputs = function LockedInputs(_ref17) {
  var fields = _ref17.fields,
    values = _ref17.values,
    onOpenCitation = _ref17.onOpenCitation;
  function renderLockedSelect(field, value) {
    var _field$options4, _field$options5, _value$selectedLabels, _field$options6;
    var quickSelectRow = !!field.quick_select && !!((_field$options4 = field.options) !== null && _field$options4 !== void 0 && _field$options4.length);
    var options = (_field$options5 = field.options) !== null && _field$options5 !== void 0 && _field$options5.length ? field.options : ((_value$selectedLabels = value.selectedLabels) !== null && _value$selectedLabels !== void 0 ? _value$selectedLabels : []).map(function (label) {
      return {
        label: label
      };
    });
    var otherSelected = value.selected.includes(_icertis.OTHER_INDEX);
    var selected = (_field$options6 = field.options) !== null && _field$options6 !== void 0 && _field$options6.length ? value.selected : [].concat(_toConsumableArray(options.map(function (_, index) {
      return index;
    })), _toConsumableArray(otherSelected ? [_icertis.OTHER_INDEX] : []));
    var otherAnswer = otherSelected && value.otherText ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-body-sm",
      children: value.otherText
    }) : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChoiceRow, {
        options: options,
        selected: selected,
        type: choiceTypeFor(field),
        disabled: true,
        row: quickSelectRow,
        showDescriptions: !quickSelectRow,
        allowOther: quickSelectRow ? offersTypedOtherAnswer(field, options) : otherSelected,
        onOpenCitation: onOpenCitation,
        "data-sentry-element": "ChoiceRow",
        "data-sentry-source-file": "CollectInputForm.tsx"
      }), otherAnswer]
    });
  }
  function renderLockedBody(field, value) {
    if (isSelectField(field)) {
      return renderLockedSelect(field, (value === null || value === void 0 ? void 0 : value.type) === "select" ? value : {
        type: "select",
        selected: []
      });
    }
    if (field.type === "editor_sides") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(EditorSidesBoard, {
        field: field,
        editors: (value === null || value === void 0 ? void 0 : value.type) === "editor_sides" ? value.editors : field.editors,
        confirmed: true,
        actingForTheCounterparty: (0, _editorSidesParty.actsForTheCounterparty)(field, fields, values),
        onMove: null
      });
    }
    if (field.type === "list") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChipListInput, {
        controlId: field.id,
        itemType: field.item_type,
        items: (value === null || value === void 0 ? void 0 : value.type) === "list" ? value.items : [],
        disabled: true
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: field.type === "long_text" ? "text-body-sm whitespace-pre-wrap" : "text-body-sm",
        children: fieldAnswerStrings(field, value).join(", ")
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldNote, {
        field: field,
        onOpenCitation: onOpenCitation,
        "data-sentry-element": "FieldNote",
        "data-sentry-source-file": "CollectInputForm.tsx"
      })]
    });
  }
  function renderLockedField(field) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldFrame, {
      field: field,
      "data-sentry-element": "FieldFrame",
      "data-sentry-component": "renderLockedField",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: renderLockedBody(field, values[field.id])
    }, field.id);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldList, {
    fields: fields.filter(function (field) {
      return field.id in values;
    }),
    renderField: renderLockedField,
    "data-sentry-element": "FieldList",
    "data-sentry-component": "LockedInputs",
    "data-sentry-source-file": "CollectInputForm.tsx"
  });
};
var CollectInputForm = exports.CollectInputForm = function CollectInputForm(_ref18) {
  var title = _ref18.title,
    fields = _ref18.fields,
    reason = _ref18.reason,
    submit = _ref18.submit,
    streaming = _ref18.streaming,
    sendMessage = _ref18.sendMessage,
    answer = _ref18.answer,
    onSubmitted = _ref18.onSubmitted,
    fetchLookupOptions = _ref18.fetchLookupOptions,
    templateSelection = _ref18.templateSelection,
    formId = _ref18.formId,
    onOpenCitation = _ref18.onOpenCitation;
  var locksAfterSubmit = submit.kind !== "open_link";
  var sendsWhenAnswered = submit.kind === "send_when_answered";
  function seededValues() {
    return initialValues(fields, locksAfterSubmit ? undefined : answer === null || answer === void 0 ? void 0 : answer.values);
  }
  var _useState3 = (0, _react.useState)(seededValues),
    _useState4 = _slicedToArray(_useState3, 2),
    untouchedValues = _useState4[0],
    setUntouchedValues = _useState4[1];
  var _useState5 = (0, _react.useState)(function () {
      return untouchedValues;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    editedValues = _useState6[0],
    setValues = _useState6[1];
  var _useState7 = (0, _react.useState)(!streaming),
    _useState8 = _slicedToArray(_useState7, 2),
    seededFromFinishedFields = _useState8[0],
    setSeededFromFinishedFields = _useState8[1];
  if (!streaming && !seededFromFinishedFields) {
    var finishedValues = seededValues();
    setSeededFromFinishedFields(true);
    setUntouchedValues(finishedValues);
    setValues(finishedValues);
  }
  var values = streaming ? initialValues(fields, undefined) : editedValues;
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isSubmitting = _useState0[0],
    setIsSubmitting = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    submitted = _useState10[0],
    setSubmitted = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    submitError = _useState12[0],
    setSubmitError = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isTypingAnswer = _useState14[0],
    setIsTypingAnswer = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    copyFeedback = _useState16[0],
    setCopyFeedback = _useState16[1];
  var copyResetRef = (0, _react.useRef)(null);
  var resolvedOptionsRef = (0, _react.useRef)({});
  var rememberResolvedOptions = (0, _react.useCallback)(function (fieldId, options) {
    resolvedOptionsRef.current[fieldId] = options;
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      if (copyResetRef.current) clearTimeout(copyResetRef.current);
    };
  }, []);
  var fieldWasEdited = function fieldWasEdited(field) {
    return editedValues[field.id] !== untouchedValues[field.id];
  };
  var answerLabelsIn = function answerLabelsIn(valuesToRead) {
    return function (fieldId) {
      var field = fields.find(function (candidate) {
        return candidate.id === fieldId;
      });
      return field ? answerLabels(field, valuesToRead[fieldId], resolvedOptionsRef.current) : [];
    };
  };
  var answerLabelsFor = answerLabelsIn(values);
  var fieldsRevealedByAnswers = (0, _collectInputDependencies.shownCollectInputFields)(fields, answerLabelsFor);
  var templatePickField = templateSelection ? fieldsRevealedByAnswers.find(isTemplatePickField) : undefined;
  var templatePickNames = templateSelection && templatePickField ? (0, _templateSelection.templatesStillValidAboveField)(templateSelection, fieldsRevealedByAnswers, templatePickField.id, answerLabelsFor) : [];
  var shownFields = templatePickField && templatePickNames.length === 0 ? fieldsRevealedByAnswers.filter(function (field) {
    return field !== templatePickField;
  }) : fieldsRevealedByAnswers;
  var blockers = submitBlockers(shownFields, values, resolvedOptionsRef.current);
  var allAnswered = blockers.length === 0;
  function inlineErrorFor(field) {
    if (!fieldCanBlockSubmit(field)) return undefined;
    var blocker = blockers.find(function (candidate) {
      return candidate.fieldId === field.id;
    });
    if (!blocker || blocker.kind === "required") return null;
    return blocker.message;
  }
  function requiredAnswerMissingFor(field) {
    return fieldWasEdited(field) && blockers.some(function (candidate) {
      return candidate.fieldId === field.id && candidate.kind === "required";
    });
  }
  var updateFieldValue = function updateFieldValue(field, nextValue) {
    setSubmitError(null);
    setValues(function (prev) {
      var next = _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, field.id, nextValue(prev[field.id])));
      var _iterator2 = _createForOfIteratorHelper((0, _collectInputDependencies.staleFieldsAfterChange)(fields, field.id, answerLabelsIn(next))),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var staleField = _step2.value;
          next[staleField.id] = initialValue(staleField);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (templateSelection) {
        var nextAnswerLabelsFor = answerLabelsIn(next);
        var nextShownFields = (0, _collectInputDependencies.shownCollectInputFields)(fields, nextAnswerLabelsFor);
        var _iterator3 = _createForOfIteratorHelper(fields.filter(isTemplatePickField)),
          _step3;
        try {
          var _loop = function _loop() {
            var pickField = _step3.value;
            var namesStillValid = (0, _templateSelection.templatesStillValidAboveField)(templateSelection, nextShownFields, pickField.id, nextAnswerLabelsFor);
            if (!nextAnswerLabelsFor(pickField.id).every(function (label) {
              return namesStillValid.includes(label);
            })) {
              next[pickField.id] = initialValue(pickField);
            }
          };
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return next;
    });
  };
  var setSelect = function setSelect(field, index) {
    updateFieldValue(field, function (current) {
      var selected = (current === null || current === void 0 ? void 0 : current.type) === "select" ? current.selected : [];
      var otherText = (current === null || current === void 0 ? void 0 : current.type) === "select" ? current.otherText : "";
      if (field.type === "multi_select") {
        var next = selected.includes(index) ? selected.filter(function (value) {
          return value !== index;
        }) : [].concat(_toConsumableArray(selected), [index]);
        return {
          type: "select",
          selected: next,
          otherText: otherText
        };
      }
      return {
        type: "select",
        selected: [index],
        otherText: otherText
      };
    });
  };
  var setOtherText = function setOtherText(field, text) {
    updateFieldValue(field, function (current) {
      var selected = (current === null || current === void 0 ? void 0 : current.type) === "select" ? current.selected : [];
      return {
        type: "select",
        selected: selected,
        otherText: text
      };
    });
  };
  var setText = function setText(field, text) {
    updateFieldValue(field, function () {
      return {
        type: "text",
        value: text
      };
    });
  };
  var setListItems = function setListItems(field, items) {
    updateFieldValue(field, function () {
      return {
        type: "list",
        items: items
      };
    });
  };
  var setEditorSide = function setEditorSide(field, editorName, side) {
    setValues(function (prev) {
      var current = prev[field.id];
      var editors = (current === null || current === void 0 ? void 0 : current.type) === "editor_sides" ? current.editors : field.editors;
      var moved = editors.map(function (editor) {
        return editor.name === editorName ? _objectSpread(_objectSpread({}, editor), {}, {
          side: side,
          unsure: false
        }) : editor;
      });
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, field.id, {
        type: "editor_sides",
        editors: moved
      }));
    });
  };
  var setCurrency = function setCurrency(field, next) {
    updateFieldValue(field, function (current) {
      var _next$amount, _next$currency;
      var amount = (_next$amount = next.amount) !== null && _next$amount !== void 0 ? _next$amount : (current === null || current === void 0 ? void 0 : current.type) === "currency" ? current.amount : "";
      var currency = (_next$currency = next.currency) !== null && _next$currency !== void 0 ? _next$currency : (current === null || current === void 0 ? void 0 : current.type) === "currency" ? current.currency : "";
      return {
        type: "currency",
        amount: amount,
        currency: currency
      };
    });
  };
  function collectAnswer() {
    var answerValues = {};
    var _iterator4 = _createForOfIteratorHelper(shownFields),
      _step4;
    try {
      var _loop2 = function _loop2() {
        var field = _step4.value;
        var value = values[field.id];
        if (isSelectField(field) && (value === null || value === void 0 ? void 0 : value.type) === "select") {
          var options = fieldOptions(field, resolvedOptionsRef.current);
          answerValues[field.id] = _objectSpread(_objectSpread({}, value), {}, {
            selectedLabels: value.selected.map(function (index) {
              return selectedOptionAnswer(options, index);
            }).filter(function (label) {
              return label !== null;
            })
          });
        } else {
          answerValues[field.id] = value;
        }
      };
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return {
      values: answerValues
    };
  }
  function answerTextFor(fieldId) {
    var picked = (0, _editorSidesParty.fieldsAndValuesForThePickedParty)(shownFields, values, resolvedOptionsRef.current);
    var field = picked.fields.find(function (candidate) {
      return candidate.id === fieldId;
    });
    if (!field) return "";
    var parts = fieldAnswerStrings(field, picked.values[fieldId], resolvedOptionsRef.current);
    return parts.join(field.type === "list" ? "," : ", ");
  }
  var handleSubmit = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var sent, result, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(!allAnswered || isSubmitting || !sendMessage)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsSubmitting(true);
            setSubmitError(null);
            _context.p = 2;
            _context.n = 3;
            return sendMessage(collectInputSubmissionMessage(title, shownFields, values, resolvedOptionsRef.current, formId));
          case 3:
            sent = _context.v;
            if (sent) {
              _context.n = 4;
              break;
            }
            setSubmitError(SUBMIT_REFUSED_MESSAGE);
            return _context.a(2);
          case 4:
            result = collectAnswer();
            _context.n = 5;
            return onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted(result);
          case 5:
            setSubmitted(result);
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            setSubmitError(SUBMIT_FAILED_MESSAGE);
          case 7:
            _context.p = 7;
            setIsSubmitting(false);
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return function handleSubmit() {
      return _ref19.apply(this, arguments);
    };
  }();
  var lockedAnswer = locksAfterSubmit && !streaming ? answer !== null && answer !== void 0 ? answer : submitted : null;
  var sendsByItself = sendsWhenAnswered && shownFields.every(isAnsweredInOneEntry);
  var readyToSendOnItsOwn = sendsByItself && !streaming && !lockedAnswer && !submitError && !isTypingAnswer && allAnswered && fields.some(function (field) {
    return fieldWasEdited(field);
  });
  (0, _react.useEffect)(function () {
    if (readyToSendOnItsOwn) void handleSubmit();
  }, [readyToSendOnItsOwn]);
  var entryEventProps = {
    onFocus: function onFocus(event) {
      return setIsTypingAnswer(isTypedInto(event.target));
    },
    onBlur: function onBlur(event) {
      var windowLostFocusWhileTyping = event.target === document.activeElement && isTypedInto(event.target);
      setIsTypingAnswer(windowLostFocusWhileTyping || isTypedInto(event.relatedTarget));
    },
    onKeyDown: function onKeyDown(event) {
      var entry = event.target;
      var endsEntry = sendsByItself && event.key === "Enter" && !event.defaultPrevented && !event.nativeEvent.isComposing;
      if (endsEntry && entry instanceof HTMLInputElement && isTypedInto(entry)) entry.blur();
    }
  };
  var sendHint = sendsByItself && isTypingAnswer && allAnswered ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    role: "status",
    className: "text-caption text-foreground-muted",
    children: "Press Enter or click away to send."
  }) : null;
  function handleOpenLink() {
    setSubmitError(null);
    void Promise.resolve(onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted(collectAnswer())).catch(function () {
      return setSubmitError("Could not save your answers.");
    });
  }
  function handleCopy(_x) {
    return _handleCopy.apply(this, arguments);
  }
  function _handleCopy() {
    _handleCopy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(field) {
      var value, copied;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            value = values[field.id];
            _context2.n = 1;
            return (0, _copyRichText.copyPlainText)((value === null || value === void 0 ? void 0 : value.type) === "text" ? value.value : "");
          case 1:
            copied = _context2.v;
            setCopyFeedback({
              fieldId: field.id,
              outcome: copied ? "copied" : "failed"
            });
            if (copyResetRef.current) clearTimeout(copyResetRef.current);
            copyResetRef.current = setTimeout(function () {
              return setCopyFeedback(null);
            }, COPY_FEEDBACK_MS);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _handleCopy.apply(this, arguments);
  }
  function renderTemplatePickField(field) {
    var _field$options7;
    var value = values[field.id];
    var selected = (value === null || value === void 0 ? void 0 : value.type) === "select" ? value.selected : [];
    var templates = templateSelection ? (0, _templateSelection.availableTemplatesAboveField)(templateSelection, fields, fieldsRevealedByAnswers, field.id, answerLabelsFor) : [];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TemplatePickChoices, {
      options: (_field$options7 = field.options) !== null && _field$options7 !== void 0 ? _field$options7 : [],
      templates: templates,
      selected: selected,
      disabled: streaming,
      onPick: function onPick(optionIndex) {
        return setSelect(field, optionIndex);
      },
      "data-sentry-element": "TemplatePickChoices",
      "data-sentry-component": "renderTemplatePickField",
      "data-sentry-source-file": "CollectInputForm.tsx"
    });
  }
  function renderSelectField(field) {
    var _value$otherText3, _field$options8;
    var type = choiceTypeFor(field);
    var value = values[field.id];
    var selected = (value === null || value === void 0 ? void 0 : value.type) === "select" ? value.selected : [];
    var otherText = (value === null || value === void 0 ? void 0 : value.type) === "select" ? (_value$otherText3 = value.otherText) !== null && _value$otherText3 !== void 0 ? _value$otherText3 : "" : "";
    var otherActive = selected.includes(_icertis.OTHER_INDEX);
    var otherInput = otherActive ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireInput, {
      placeholder: "Type your answer",
      "aria-label": "".concat(field.label, " \u2014 other answer"),
      value: otherText,
      disabled: streaming,
      onChange: function onChange(e) {
        return setOtherText(field, e.target.value);
      }
    }) : null;
    var toggle = function toggle(index) {
      return setSelect(field, index);
    };
    var otherChoiceAmong = function otherChoiceAmong(options) {
      return offersTypedOtherAnswer(field, options) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ChoiceRow, {
        options: [],
        selected: selected,
        type: type,
        disabled: streaming,
        onToggle: toggle,
        allowOther: true
      }) : null;
    };
    var optionsUrlTemplate = (_field$options8 = field.options) !== null && _field$options8 !== void 0 && _field$options8.length ? null : field.options_url;
    var optionsUrl = optionsUrlTemplate ? (0, _collectInputDependencies.resolveOptionsUrl)(optionsUrlTemplate, answerLabelsFor) : null;
    var unansweredParent = optionsUrlTemplate && !optionsUrl ? fields.find(function (candidate) {
      return (0, _collectInputDependencies.optionsUrlFieldIds)(optionsUrlTemplate).includes(candidate.id) && !answerLabelsFor(candidate.id).length;
    }) : undefined;
    if (unansweredParent) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        role: "status",
        className: "text-caption text-foreground-muted",
        children: ["Choose ", unansweredParent.label, " first."]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectFieldOptions, {
      field: field,
      optionsUrl: optionsUrl,
      fetchLookupOptions: fetchLookupOptions,
      onResolved: rememberResolvedOptions,
      "data-sentry-element": "SelectFieldOptions",
      "data-sentry-component": "renderSelectField",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: function children(options, isLoading, loadError) {
        return isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          role: "status",
          className: "flex items-center gap-2 text-caption text-foreground-muted",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
            "aria-hidden": true
          }), "Loading options\u2026"]
        }) : loadError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireError, {
          children: loadError
        }) : field.quick_select ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChoiceRow, {
            options: options,
            selected: selected,
            type: type,
            disabled: streaming,
            onToggle: toggle,
            row: true,
            showDescriptions: false,
            allowOther: offersTypedOtherAnswer(field, options)
          }), otherInput]
        }) : options.length > _lookupOptions.SEARCHABLE_OPTIONS_THRESHOLD ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchableSelect.SearchableSelect, {
            options: options,
            selected: selected,
            multiSelect: field.type === "multi_select",
            disabled: streaming,
            onToggle: toggle,
            label: "Search ".concat(field.label, " options")
          }), otherChoiceAmong(options), otherInput]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChoiceRow, {
            options: options,
            selected: selected,
            type: type,
            disabled: streaming,
            onToggle: toggle,
            allowOther: offersTypedOtherAnswer(field, options),
            onOpenCitation: onOpenCitation
          }), otherInput]
        });
      }
    });
  }
  function renderEditorSidesField(field) {
    var value = values[field.id];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(EditorSidesBoard, {
      field: field,
      editors: (value === null || value === void 0 ? void 0 : value.type) === "editor_sides" ? value.editors : field.editors,
      confirmed: false,
      actingForTheCounterparty: (0, _editorSidesParty.actsForTheCounterparty)(field, fields, values, resolvedOptionsRef.current),
      onMove: streaming ? null : function (editorName, side) {
        return setEditorSide(field, editorName, side);
      },
      "data-sentry-element": "EditorSidesBoard",
      "data-sentry-component": "renderEditorSidesField",
      "data-sentry-source-file": "CollectInputForm.tsx"
    });
  }
  function renderCurrencyField(field) {
    var _field$currencies$;
    var value = values[field.id];
    var amount = (value === null || value === void 0 ? void 0 : value.type) === "currency" ? value.amount : "";
    var currency = (value === null || value === void 0 ? void 0 : value.type) === "currency" ? value.currency : (_field$currencies$ = field.currencies[0]) !== null && _field$currencies$ !== void 0 ? _field$currencies$ : "";
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroup, {
      "data-sentry-element": "InputGroup",
      "data-sentry-component": "renderCurrencyField",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupInput, {
        id: field.id,
        type: "number",
        value: amount,
        disabled: streaming,
        onChange: function onChange(e) {
          return setCurrency(field, {
            amount: e.target.value
          });
        },
        "data-sentry-element": "InputGroupInput",
        "data-sentry-source-file": "CollectInputForm.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, {
        align: "inline-end",
        "data-sentry-element": "InputGroupAddon",
        "data-sentry-source-file": "CollectInputForm.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
          value: currency,
          disabled: streaming,
          onValueChange: function onValueChange(code) {
            return setCurrency(field, {
              currency: code
            });
          },
          "data-sentry-element": "Select",
          "data-sentry-source-file": "CollectInputForm.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
            size: "sm",
            "aria-label": "".concat(field.label, " currency"),
            "data-sentry-element": "SelectTrigger",
            "data-sentry-source-file": "CollectInputForm.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
              "data-sentry-element": "SelectValue",
              "data-sentry-source-file": "CollectInputForm.tsx",
              children: currency
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
            "data-sentry-element": "SelectContent",
            "data-sentry-source-file": "CollectInputForm.tsx",
            children: field.currencies.map(function (code) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                value: code,
                children: code
              }, code);
            })
          })]
        })
      })]
    });
  }
  function renderTextField(field) {
    var value = values[field.id];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
      id: field.id,
      type: field.type === "date" ? "date" : field.type === "number" ? "number" : "text",
      value: (value === null || value === void 0 ? void 0 : value.type) === "text" ? value.value : "",
      disabled: streaming,
      onChange: function onChange(e) {
        return setText(field, e.target.value);
      },
      "data-sentry-element": "Input",
      "data-sentry-component": "renderTextField",
      "data-sentry-source-file": "CollectInputForm.tsx"
    });
  }
  function renderLongTextField(field) {
    var value = values[field.id];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
      id: field.id,
      className: "min-h-29 max-h-149 overflow-y-auto md:min-h-25 md:max-h-125",
      value: (value === null || value === void 0 ? void 0 : value.type) === "text" ? value.value : "",
      disabled: streaming,
      onChange: function onChange(e) {
        return setText(field, e.target.value);
      },
      "data-sentry-element": "Textarea",
      "data-sentry-component": "renderLongTextField",
      "data-sentry-source-file": "CollectInputForm.tsx"
    });
  }
  function renderCopyButton(field) {
    if (!field.copyable) return null;
    var outcome = (copyFeedback === null || copyFeedback === void 0 ? void 0 : copyFeedback.fieldId) === field.id ? copyFeedback.outcome : null;
    var label = outcome ? COPY_OUTCOME_LABELS[outcome] : "Copy";
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "xs",
      className: "ms-auto",
      "aria-label": outcome ? label : "Copy ".concat(field.label),
      disabled: streaming,
      onClick: function onClick() {
        return handleCopy(field);
      },
      "data-sentry-element": "Button",
      "data-sentry-component": "renderCopyButton",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: [outcome === "copied" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ContentCopyIcon, {}), label]
    });
  }
  function renderFieldBody(field) {
    if (isTemplatePickField(field) && templateSelection) return renderTemplatePickField(field);
    if (isSelectField(field)) return renderSelectField(field);
    if (field.type === "editor_sides") return renderEditorSidesField(field);
    if (field.type === "list") {
      var value = values[field.id];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChipListInput, {
        controlId: field.id,
        itemType: field.item_type,
        items: (value === null || value === void 0 ? void 0 : value.type) === "list" ? value.items : [],
        disabled: streaming,
        onChange: function onChange(items) {
          return setListItems(field, items);
        }
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [field.type === "long_text" ? renderLongTextField(field) : field.type === "currency" ? renderCurrencyField(field) : renderTextField(field), /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldNote, {
        field: field,
        onOpenCitation: onOpenCitation,
        "data-sentry-element": "FieldNote",
        "data-sentry-source-file": "CollectInputForm.tsx"
      })]
    });
  }
  function renderField(field) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldFrame, {
      field: field,
      controlId: isSelectField(field) || field.type === "editor_sides" ? undefined : field.id,
      trailing: field.type === "long_text" ? renderCopyButton(field) : null,
      error: inlineErrorFor(field),
      requiredAnswerMissing: requiredAnswerMissingFor(field),
      "data-sentry-element": "FieldFrame",
      "data-sentry-component": "renderField",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: renderFieldBody(field)
    }, field.id);
  }
  var submitErrorEl = submitError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireError, {
    role: undefined,
    children: submitError
  }) : null;
  function renderSubmitControl() {
    if (streaming) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireSubmit, {
        type: "button",
        disabled: true,
        children: submit.kind === "open_link" ? submit.label : "Submit"
      });
    }
    if (submit.kind === "open_link") {
      var href = allAnswered ? (0, _collectInputLinkHref.buildCollectInputLinkHref)(submit.href_template, answerTextFor) : null;
      if (href) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireSubmit, {
          type: undefined,
          asChild: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: href,
            target: (0, _collectInputLinkHref.collectInputLinkTarget)(href),
            rel: "noopener noreferrer",
            onClick: handleOpenLink,
            children: submit.label
          })
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitBlockedTooltip, {
        blockers: blockers,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireSubmit, {
          type: "button",
          disabled: true,
          children: submit.label
        })
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitBlockedTooltip, {
      blockers: blockers,
      "data-sentry-element": "SubmitBlockedTooltip",
      "data-sentry-component": "renderSubmitControl",
      "data-sentry-source-file": "CollectInputForm.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireSubmit, {
        type: "button",
        onClick: handleSubmit,
        disabled: !allAnswered || isSubmitting,
        "data-sentry-element": "QuestionnaireSubmit",
        "data-sentry-source-file": "CollectInputForm.tsx"
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormCard, {
    title: title,
    reason: reason,
    formId: formId,
    questionnaireProps: sendsWhenAnswered ? entryEventProps : undefined,
    "data-sentry-element": "FormCard",
    "data-sentry-component": "CollectInputForm",
    "data-sentry-source-file": "CollectInputForm.tsx",
    children: lockedAnswer ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LockedInputs, {
      fields: fields,
      values: lockedAnswer.values,
      onOpenCitation: onOpenCitation
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FieldList, {
        fields: shownFields,
        renderField: renderField
      }), sendHint, submitErrorEl, sendsByItself && !submitError ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_questionnaire.QuestionnaireActions, {
        children: renderSubmitControl()
      })]
    })
  });
};